import { render, staticRenderFns } from "./DrawerSpaceSection.vue?vue&type=template&id=28154678&"
import script from "./DrawerSpaceSection.vue?vue&type=script&lang=js&"
export * from "./DrawerSpaceSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports